/**
 * Consent-aware Google Analytics event tracking utilities.
 *
 * These wrappers respect cookie consent — if the user has not consented
 * (gtag is not loaded), calls are silently ignored.
 */

/**
 * Track a custom GA4 event.
 *
 * @param {string} name  - Event name (e.g., 'entry_created', 'room_joined')
 * @param {Object} [params] - Optional event parameters
 */
export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

/**
 * Track a timing/duration metric.
 *
 * @param {string} name  - Timing metric name (e.g., 'board_load_time')
 * @param {number} value - Duration in milliseconds
 */
export function trackTiming(name, value) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'timing_complete', {
    name,
    value: Math.round(value),
  });
}
